<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import Confirm from './components/global/Confirm.vue';

const defaultLayout = 'default';

export default {
  components: { Confirm },
  computed: {
    layout() {
      return (`${this.$route.meta.layout || defaultLayout}-layout`);
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;
  },
};
</script>

<style lang="scss">
@import "~@/scss/main";
</style>
